export default __webpack_public_path__ + "media/exports/required/assets/img/images/brand_black-2ab041442433c5f6f2083183b5fab31a.png";